import Vue from 'vue'
import helper from '@/plugins/helper'
import App from '@/App.vue'
import '@/plugins/vuetify'
import '@/components'
import VueRouter from 'vue-router'

const routes = [{ path: '/:lang', component: App }]

const router = new VueRouter({ mode: 'history', routes })

Vue.config.productionTip = false
Vue.use(helper)
Vue.use(VueRouter)

new Vue({ router, render: (h) => h(App) }).$mount('#app')
